import { Component, ElementRef, ViewChild } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import moment from 'moment';
import { AdminBreadcrumbsService } from '../../admin-services/admin-breadcrumbs.service';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Categories,
  LoginModel,
  MainDepartment,
  Stores,
  subCategories
} from '../../../../Models/ApplicationModels';
import { MasterDataSeriveService } from '../../../../Services/master-data-serive.service';
import { DatePipe } from '@angular/common';
import { OverrideStatus } from 'src/app/enum/enum';
import {
  ProductionCycle,
  ProductionCycleSchedule
} from '../../company-config/WeekColors/models/week-color.model';
import { WeekColorService } from '../../company-config/WeekColors/services/week-color.service';
@Component({
  selector: 'app-sell-through-report',
  templateUrl: './sell-through-report.component.html',
  styleUrls: ['./sell-through-report.component.css']
})
export class SellThroughReportComponent {
  @ViewChild('dateRange') dateRange!: ElementRef<HTMLElement>;

  reportType: string[] = [
    'Sales Summary',
    'User',
    'Outlet',
    'Register',
    'Customer',
    'Customer Group',
    'Promotions',
    '....',
    'Product',
    'Sku Name',
    'Brand',
    'Supplier',
    'Category',
    'Tag'
  ];

  measure: string[] = [
    'Revenue',
    'Revenue (incl. tax)',
    'avg. Item per sale',
    'avg. Sale value',
    'avg. Sale value (incl. tax)',
    'cost of goods sold',
    'customer count',
    'discounted',
    'discounted %',
    'first sale',
    'last sale',
    'gross profit',
    'items sold',
    'margin %',
    'return count',
    'return %',
    'Sale Count',
    'Sales with customer attached',
    'Tax'
  ];

  reportTypeOption: string = 'All Stores';

  OutOfStockColumnName: any[] = [
    { columnId: 1, columnName: 'Produced' },
    { columnId: 2, columnName: 'Produced Total' },
    { columnId: 3, columnName: 'Avg. Price' },
    { columnId: 4, columnName: 'Sell through' },
    { columnId: 5, columnName: 'Total Sold' },
    { columnId: 16, columnName: 'Avg. Price Sold' },
    { columnId: 6, columnName: 'Item Discounted' },
    { columnId: 7, columnName: 'Discounted Amount' },
    { columnId: 10, columnName: 'Avg. Day on Floor' },
    { columnId: 11, columnName: 'Current on-hand' },
    { columnId: 12, columnName: 'Potential Revenue' },
    { columnId: 14, columnName: 'Sell-through %' },
    { columnId: 15, columnName: 'Trend' }
  ];
  modalColumns: any[] = [
    { columnId: 1, columnName: 'Produced' },
    { columnId: 2, columnName: 'Produced Total' },
    { columnId: 3, columnName: 'Avg. Price' },
    { columnId: 4, columnName: 'Sell through' },
    { columnId: 5, columnName: 'Total Sold' },
    { columnId: 16, columnName: 'Avg. Price Sold' },
    { columnId: 6, columnName: 'Item Discounted' },
    { columnId: 7, columnName: 'Discounted Amount' },
    { columnId: 10, columnName: 'Avg. Day on Floor' },
    { columnId: 11, columnName: 'Current on-hand' },
    { columnId: 12, columnName: 'Potential Revenue' },
    { columnId: 14, columnName: 'Sell-through %' }
  ];

  salesGraph: any;
  startDate: any;
  endDate: any;
  charts: Chart[] = [];
  noChartData: boolean = true;
  empTableData: any[] = [];
  userInfo: LoginModel = new LoginModel();
  stores: Array<Stores> = [];
  deptName: string = 'All departments';
  categoryName: string = 'All categories';
  subCategoryName: string = 'All subcategories';
  storeName: string = 'All stores';
  deptNames: Array<string> = [];
  deptIDs: Array<number> = [];
  deptId: string = '0';
  storeNames: Array<string> = [];
  storeIds: Array<number> = [];
  storeId: string = '0';
  storeID: number = 0;
  userID: number = 0;
  categoryId: number = 0;
  subCategoryId: number = 0;
  isLoading: boolean = false;
  reportHasRun: boolean = false;
  headerCheckboxSelected: boolean = false;
  headerDeptCheckboxSelected: boolean = false;

  producersColumns = [
    { columnID: 1, columnName: 'Produced' },
    { columnID: 2, columnName: 'Total' },
    { columnID: 3, columnName: 'Avg. Days on Floor' },
    { columnID: 4, columnName: 'Potential Revenue' },
    { columnID: 6, columnName: 'Sell-through %' },
    { columnID: 7, columnName: 'Trend' }
  ];

  reportHead: string = 'ALL STORES SELECTED | ALL DEPARTMENTS / all categories';
  mainDepartmentList: Array<MainDepartment> = [];
  categorieslist: Array<Categories> = [];
  subCategorieslist: Array<subCategories> = [];
  disableCategory: boolean = true;
  disableSubCategory: boolean = true;
  sellThroughData: any;
  sellThroughDeptData: any[] = [];
  sellThroughDeptTableData: any[] = [];
  modalStoreName: string = '';
  modalUserName: string = '';
  noDataFound: boolean = false;
  usersArray: any;
  chartUserName: string = 'Over All';
  chartStoreName: string = '';
  chartLabels: Array<string> = [];
  sellThroughChart: { date: string; sellThroughPercentage: number }[] = [];
  weekColor: string = 'All Week Colors';
  weekColorsList: Array<ProductionCycle> = [];
  weekColorSchedule: Array<ProductionCycleSchedule> = [];
  productionCycleId: number = 0;
  weekColorHeaderSelected: boolean = false;
  departmentCategoriesMap: Map<number, Categories[]> = new Map();
  showWeekColor: boolean = true;
  grandTotal: any[] = [];

  constructor(
    private masterService: MasterDataSeriveService,
    private adminBreadcrumbs: AdminBreadcrumbsService,
    private datepipe: DatePipe,
    private weekColorService: WeekColorService
  ) {}
  ngOnInit() {
    this.adminBreadcrumbs.updateBreadcrumbs([
      { crumbName: 'Reports', link: 'demo' },
      { crumbName: 'Sell through report', link: '/admin/home/sell-through' }
    ]);
    this.userInfo = JSON.parse(localStorage.getItem('user')!);
    const productionScheduleType = (
      this.userInfo as any
    )?.productionScheduleType
      ?.toString()
      ?.trim()
      ?.toLowerCase();
    this.showWeekColor = productionScheduleType !== 'datespecific';
    this.getStores();
    if (this.showWeekColor) {
      this.getWeekColors();
    } else {
      this.productionCycleId = 0;
      this.weekColor = 'All Week Colors';
    }
    if (this.showWeekColor) {
      this.getWeekColors();
    } else {
      this.productionCycleId = 0;
      this.weekColor = 'All Week Colors';
    }
    this.getMainDepartments();
    this.startDate = moment().format('MM-DD-YYYY');
    this.endDate = moment().format('MM-DD-YYYY');
  }

  runReport() {
    this.reportHasRun = true;
    this.getSellThroughReport();
  }

  /*date range picker */
  public options: any = {
    locale: {
      format: 'MM/DD/YYYY',
      separator: ' - ',
      applyLabel: 'Apply',
      cancelLabel: 'Cancel'
    },
    alwaysShowCalendars: true,
    showDropdowns: false,
    showCustomRangeLabel: true,
    maxDate: new Date(),
    ranges: {
      Today: [moment(), moment()],
      Yesterday: [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
      'This Week': [moment().startOf('week'), moment()],
      'Last Week': [
        moment().subtract(1, 'week').startOf('week'),
        moment().subtract(1, 'week').endOf('week')
      ],
      'This Month': [moment().startOf('month'), moment().endOf('month')],
      'Last Month': [
        moment().subtract(1, 'month').startOf('month'),
        moment().subtract(1, 'month').endOf('month')
      ]
    },
    opens: 'left'
  };

  public selectedDate(value: any) {
    this.endDate = value.end._d;
    this.startDate = value.start._d;
  }

  openCalender() {
    if (this.dateRange) {
      this.dateRange.nativeElement.click();
    }
  }

  /*filters methods*/
  getStores() {
    const user = this.masterService.getUserDetailsFromStorage();
    this.masterService.getallstores(user.companyID).subscribe((res) => {
      if (Array.isArray(res)) {
        for (const item of res) {
          this.stores.push(item);
        }
      }
      this.storeID = this.stores[0]?.storeId;
      this.chartStoreName = this.stores[0]?.storeName;
    });
  }

  getMainDepartments() {
    this.masterService.getDepartmentsProduction(false, 0).subscribe(
      (response: any) => {
        this.mainDepartmentList = response as MainDepartment[];
        this.mainDepartmentList.forEach((d) => (d.isSelected = false));
      },
      () => {}
    );
  }

  getCategoriesByDeptId(deptId: number) {
    this.masterService
      .getCategoriesByDeptUserID(deptId, this.userInfo.userId, false, 0)
      .subscribe((res) => {
        this.categoryName = 'All categories';
        this.categorieslist = res as Categories[];
        this.resetSubCategory();
      });
  }

  getSubCategoriesByCategoryId(categoryId: number) {
    this.masterService
      .getProductionSubCategory(
        this.userInfo.companyID,
        this.deptIDs[this.deptIDs.length - 1],
        categoryId
      )
      .subscribe((res) => {
        this.subCategoryName = 'All subcategories';
        this.subCategorieslist = res as subCategories[];
      });
  }

  resetSubCategory() {
    this.subCategorieslist = [];
    this.subCategoryId = 0;
    this.subCategoryName = 'All subcategories';
    this.disableSubCategory = true;
  }

  updateCategoriesList(deptId?: number, isAdding?: boolean) {
    // If no departments selected -> clear categories
    if (this.deptIDs.length === 0) {
      this.departmentCategoriesMap.clear();
      this.categorieslist = [];
      this.categoryName = 'All categories';
      this.categoryId = 0;
      this.resetSubCategory();
      return;
    }

    // If adding a department, fetch and store its categories
    if (isAdding && deptId !== undefined) {
      this.masterService
        .getCategoriesByDeptUserID(deptId, this.userInfo.userId, false, 0)
        .subscribe((res: any) => {
          this.departmentCategoriesMap.set(deptId, res as Categories[]);
          this.rebuildCategoriesList();
        });
      return;
    }

    if (!isAdding && deptId !== undefined) {
      this.departmentCategoriesMap.delete(deptId);
      this.rebuildCategoriesList();
      return;
    }

    this.rebuildCategoriesList();
  }

  rebuildCategoriesList() {
    const categoryMap = new Map<number, Categories>();
    this.departmentCategoriesMap.forEach((categories) => {
      if (Array.isArray(categories)) {
        categories.forEach((cat) => {
          if (cat && cat.categoryId !== undefined) {
            categoryMap.set(cat.categoryId, cat);
          }
        });
      }
    });
    this.categorieslist = Array.from(categoryMap.values());
    this.categoryName = 'All categories';
    this.categoryId = 0;
    this.resetSubCategory();
  }

  toggleAllCheckboxes() {
    this.headerCheckboxSelected = !this.headerCheckboxSelected;
    if (this.headerCheckboxSelected) {
      this.storeIds = this.stores.map((str) => str.storeId);
    } else {
      this.storeIds = [];
    }
    if (this.storeIds.length) {
      this.storeId = this.storeIds.join(', ');
    } else {
      this.storeName = 'All stores';
      this.storeId = '0';
    }
  }

  toggleAllDepartments() {
    this.headerDeptCheckboxSelected = !this.headerDeptCheckboxSelected;
    if (this.headerDeptCheckboxSelected) {
      this.deptNames = this.mainDepartmentList.map((d) => d.departmentDescr);
      this.deptIDs = this.mainDepartmentList.map((d) => d.departmentId);
      this.mainDepartmentList.forEach((d) => (d.isSelected = true));
      this.deptId = '0';
    } else {
      this.deptNames = [];
      this.deptIDs = [];
      this.mainDepartmentList.forEach((d) => (d.isSelected = false));
      this.deptId = '0';
    }
    if (this.deptIDs.length === this.mainDepartmentList.length) {
      this.deptId = '0';
      this.deptName = 'All departments';
    }
    this.departmentCategoriesMap.clear();
    this.rebuildCategoriesList();
  }

  selectAllDepartments() {
    this.deptName = 'All departments';
    this.deptNames = [];
    this.deptIDs = [];
    this.deptId = '0';
    this.disableCategory = true;
    this.departmentCategoriesMap.clear();
    this.categorieslist = [];
    this.categoryName = 'All categories';
    this.categoryId = 0;
    this.resetSubCategory();
  }

  selectAllcategories() {
    if (this.categorieslist.length) {
      const index = this.reportHead.indexOf('/');
      if (index !== -1) {
        this.reportHead = this.reportHead.substring(0, index);
      }
    }
    this.categoryName = 'All categories';
    this.categoryId = 0;
    this.resetSubCategory();
  }

  selectAllSubcategories() {
    if (this.subCategoryId) {
      const index = this.reportHead.lastIndexOf('/');
      if (index !== -1) {
        this.reportHead = this.reportHead.substring(0, index).trim();
      }
    }
    this.subCategoryName = 'All subcategories';
    this.subCategoryId = 0;
  }

  setOverAllOption() {
    this.chartUserName = 'Over All';
    this.userID = 0;
    this.getSellThroughChart();
  }

  setFilterNames(filterObj: any, option: number) {
    if (option === 1) {
      const nameIndex = this.deptNames.findIndex(
        (item) => item === filterObj.departmentDescr
      );
      this.reportHead = '';
      let isAdding = false;

      if (nameIndex !== -1) {
        this.deptNames.splice(nameIndex, 1);
        filterObj.isSelected = false;
        this.reportHead = this.deptNames[nameIndex - 1];
        isAdding = false;
      } else {
        this.deptNames.push(filterObj.departmentDescr);
        filterObj.isSelected = true;
        this.reportHead = filterObj.departmentDescr;
        isAdding = true;
      }

      if (this.deptNames.length > 1) {
        this.deptName =
          this.deptNames.slice(0, 1) + ' +' + `${this.deptNames.length - 1}`;
      } else {
        this.deptName = this.deptNames.join(', ');
      }

      const iDIndex = this.deptIDs.indexOf(filterObj.departmentId);
      if (iDIndex !== -1) {
        this.deptIDs.splice(iDIndex, 1);
      } else {
        this.deptIDs.push(filterObj.departmentId);
      }

      if (this.deptIDs.length) {
        this.deptId = this.deptIDs.join(',');
      } else {
        this.deptName = 'All departments';
        this.deptId = '0';
        this.disableCategory = true;
      }
      this.disableCategory = this.deptId === '0';
      this.headerDeptCheckboxSelected =
        this.deptIDs.length === this.mainDepartmentList.length;
      this.updateCategoriesList(filterObj.departmentId, isAdding);
    }

    if (option === 2) {
      const nameIndex = this.storeNames.findIndex(
        (item) => item === filterObj.storeName
      );
      if (nameIndex !== -1) {
        this.storeNames.splice(nameIndex, 1);
      } else {
        this.storeNames.push(filterObj.storeName);
      }

      if (this.storeNames.length > 1) {
        this.storeName =
          this.storeNames.slice(0, 1) + ' +' + `${this.storeNames.length - 1}`;
      } else {
        this.storeName = this.storeNames.join(', ');
      }

      const iDIndex = this.storeIds.indexOf(filterObj.storeID);
      if (iDIndex !== -1) {
        this.storeIds.splice(iDIndex, 1);
      } else {
        this.storeIds.push(filterObj.storeId);
      }

      if (this.storeIds.length) {
        this.storeId = this.storeIds.join(', ');
      } else {
        this.storeName = 'All stores';
        this.storeId = '0';
      }
      this.disableCategory = this.deptId === '0';
    }

    if (option === 3) {
      this.categoryName = filterObj.categoryName;
      this.categoryId = filterObj.categoryId;

      this.resetSubCategory();
      this.disableSubCategory = false;
      this.getSubCategoriesByCategoryId(this.categoryId);
    }

    if (option === 5) {
      this.weekColor = filterObj.displayName;
      this.productionCycleId = filterObj.id;
    }

    if (option === 6) {
      this.subCategoryName = filterObj.subCategoryName;
      this.subCategoryId = filterObj.subCategoryID || filterObj.subCategoryId;
    }
  }

  /* ------------------------------------------------------------------ */
  /* Main report data                                                     */
  /* ------------------------------------------------------------------ */
  getSellThroughReport() {
    this.isLoading = true;
    const formattedStartDate = this.datepipe.transform(
      this.startDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const formattedEndDate = this.datepipe.transform(
      this.endDate,
      'yyyy-MM-dd HH:mm:ss'
    );

    this.masterService
      .getSellThroughData(
        this.userInfo.companyID,
        this.storeId,
        this.deptId,
        this.categoryId,
        formattedStartDate,
        formattedEndDate,
        this.productionCycleId,
        this.subCategoryId
      )
      .subscribe({
        next: (res: any) => {
          const stores = res.store;
          const producers = res.producers;
          const department = res.department;
          const category = res.category;
          const storeTrend = res.storeTrend;
          const producerTrend = res.producerTrend;

          this.formateSellThroughTableData(
            stores,
            producers,
            storeTrend,
            producerTrend
          );
          this.formateSellThroughModalData(department, category);
          this.formateTopProducersData(
            stores,
            producers,
            storeTrend,
            producerTrend
          );

          setTimeout(() => {
            this.renderDynamicTrendChart(
              this.sellThroughData,
              this.empTableData
            );
          }, 100);

          this.getUsersByStore(this.storeID);

          if (res.store.length === 0) {
            this.noDataFound = true;
          } else {
            this.noDataFound = false;
          }

          if (this.sellThroughData?.length) {
            this.storeID = this.sellThroughData[0].storeID;
            this.chartStoreName = this.sellThroughData[0].storeName;
            this.getSellThroughChart();
          }
        },
        complete: () => {
          this.isLoading = false;
        }
      });
  }

  /* ------------------------------------------------------------------ */
  /* Top Producers table                                                  */
  /* ------------------------------------------------------------------ */
  formateTopProducersData(
    stores: any[],
    producers: any[],
    storeTrend: any[],
    producerTrend: any[]
  ): void {
    const producerMap = new Map<number, any>();

    producers.forEach((producer) => {
      const existing = producerMap.get(producer.ProductionStoreID);
      if (!existing || producer.ProducedQty > existing.ProducedQty) {
        producerMap.set(producer.ProductionStoreID, producer);
      }
    });

    const uniqueProducers = Array.from(producerMap.values());

    this.empTableData = uniqueProducers
      .map((producer) => {
        const storeId = producer.ProductionStoreID;
        const store = stores.find((s) => s.ProductionStoreID === storeId);

        const producerTrendData = {
          producerID: `${producer.UserID}_${storeId}`,
          data: producerTrend
            .filter(
              (trend) =>
                trend.ProductionStoreID === storeId &&
                trend.CreatedByUserId === producer.UserID
            )
            .map((trend) => ({
              date: this.datepipe.transform(trend.CreatedDate, 'MMM d')!,
              sellThroughPercentage: trend.SellThroughPercentage.toFixed(2)
            }))
        };

        return {
          UserName: producer.UserName,
          storeName: store ? store.StoreName : 'Unknown',
          prdData: [
            { columnID: 1, value: producer.ProducedQty },
            {
              columnID: 2,
              value: `$${(producer.ProducedPrice ?? 0).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}`
            },
            { columnID: 3, value: `${producer.AvgDaysOnFloor} days` },
            {
              columnID: 4,
              value: `$${(producer.PotentialRevenue ?? 0).toLocaleString(
                'en-US',
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              )}`
            },
            {
              columnID: 6,
              value: `${(producer.SellThroughPercentage ?? producer.SellThroughPercentageCreatedByUserId ?? 0).toLocaleString(
                'en-US',
                {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                }
              )}%`
            },
            { columnID: 7, value: producerTrendData }
          ]
        };
      })
      .sort((a, b) => b.prdData[0].value - a.prdData[0].value);
  }

  /* ------------------------------------------------------------------ */
  /* Main store/producer table data                                       */
  /* ------------------------------------------------------------------ */
  formateSellThroughTableData(
    stores: any,
    producers: any,
    storeTrend: any,
    producerTrend: any
  ) {
    this.sellThroughData = stores.map((store: any) => {
      const storeProducers = producers.filter(
        (p: any) => p.ProductionStoreID === store.ProductionStoreID
      );

      //  totals
      const totalProducedQty = storeProducers.reduce(
        (s: number, p: any) => s + (p.ProducedQty || 0),
        0
      );
      const totalProducedPrice = storeProducers.reduce(
        (s: number, p: any) => s + (p.ProducedPrice || 0),
        0
      );

      const totalSoldQty = storeProducers.reduce(
        (s: number, p: any) => s + (p.SoldQty || 0),
        0
      );
      const totalSoldPrice = storeProducers.reduce(
        (s: number, p: any) => s + (p.SoldPrice || 0),
        0
      );

      const totalDiscountItems = storeProducers.reduce(
        (s: number, p: any) => s + (p.DiscountedItems || 0),
        0
      );
      const totalDiscountAmount = storeProducers.reduce(
        (s: number, p: any) => s + (p.DiscountedAmount || 0),
        0
      );

      const totalOnHand = storeProducers.reduce(
        (s: number, p: any) => s + (p.OnHandItemsAmount || 0),
        0
      );
      const totalPotentialRevenue = storeProducers.reduce(
        (s: number, p: any) => s + (p.PotentialRevenue || 0),
        0
      );

      // CORRECT averages (weighted)
      const avgProducedPrice =
        totalProducedQty !== 0 ? totalProducedPrice / totalProducedQty : 0;
      const avgSoldPrice =
        totalSoldQty !== 0 ? totalSoldPrice / totalSoldQty : 0;

      const weightedDaysOnFloor =
        totalProducedQty !== 0
          ? storeProducers.reduce(
              (s: number, p: any) =>
                s + (p.AvgDaysOnFloor || 0) * (p.ProducedQty || 0),
              0
            ) / totalProducedQty
          : 0;

      //  store trend
      const storeTrendData = storeTrend
        .filter((t: any) => t.ProductionStoreID === store.ProductionStoreID)
        .map((t: any) => ({
          date: this.datepipe.transform(t.CreatedDate, 'MMM d')!,
          sellThroughPercentage: t.SellThroughPercentage.toFixed(2)
        }));

      //  producer trend
      const producerTrendData = storeProducers.map((p: any) => ({
        producerID: `${p.UserID}-${store.ProductionStoreID}`,
        data: producerTrend
          .filter(
            (t: any) =>
              t.ProductionStoreID === store.ProductionStoreID &&
              t.CreatedByUserId === p.UserID
          )
          .map((t: any) => ({
            date: this.datepipe.transform(t.CreatedDate, 'MMM d')!,
            sellThroughPercentage: t.SellThroughPercentage.toFixed(2)
          }))
      }));

      return {
        storeID: store.ProductionStoreID,
        storeName: store.StoreName,
        isProducersData: false,

        producers: storeProducers.map((p: any) => ({
          UserName: p.UserName,
          UserID: p.UserID
        })),

        //  FIXED STORE TOTALS
        storeTotal: [
          { columnId: 1, total: totalProducedQty },

          {
            columnId: 2,
            total: `$${totalProducedPrice.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}`
          },

          {
            columnId: 3, // Avg Price
            total: `$${avgProducedPrice.toFixed(2)}`
          },

          { columnId: 4, total: totalSoldQty },

          {
            columnId: 5,
            total: `$${totalSoldPrice.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}`
          },

          {
            columnId: 16, // Avg Sold Price
            total: `$${avgSoldPrice.toFixed(2)}`
          },

          { columnId: 6, total: totalDiscountItems },

          {
            columnId: 7,
            total: `$${totalDiscountAmount.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}`
          },

          {
            columnId: 10, // FIXED Avg Days on Floor
            total: weightedDaysOnFloor.toFixed(2)
          },

          {
            columnId: 11,
            total: `$${totalOnHand.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}`
          },

          {
            columnId: 12,
            total: `$${totalPotentialRevenue.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}`
          },

          {
            columnId: 14,
            total: `${store.SellThroughPercentage.toFixed(2)}%`
          },

          { columnId: 15, total: storeTrendData }
        ],

        //  Producer level (already correct from API)
        measuredValues: [
          {
            columnId: 1,
            data: storeProducers.map((p: any) => ({ value: p.ProducedQty }))
          },
          {
            columnId: 2,
            data: storeProducers.map((p: any) => ({
              value: `$${(p.ProducedPrice ?? 0).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}`
            }))
          },
          {
            columnId: 3,
            data: storeProducers.map((p: any) => ({
              value: `$${(p.AvgAmount ?? 0).toFixed(2)}`
            }))
          },
          {
            columnId: 4,
            data: storeProducers.map((p: any) => ({ value: p.SoldQty }))
          },
          {
            columnId: 5,
            data: storeProducers.map((p: any) => ({
              value: `$${(p.SoldPrice ?? 0).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}`
            }))
          },
          {
            columnId: 16,
            data: storeProducers.map((p: any) => ({
              value: `$${(p.AvgSoldPrice ?? 0).toFixed(2)}`
            }))
          },
          {
            columnId: 6,
            data: storeProducers.map((p: any) => ({ value: p.DiscountedItems }))
          },
          {
            columnId: 7,
            data: storeProducers.map((p: any) => ({
              value: `$${(p.DiscountedAmount ?? 0).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}`
            }))
          },
          {
            columnId: 10,
            data: storeProducers.map((p: any) => ({
              value: p.AvgDaysOnFloor
            }))
          },
          {
            columnId: 11,
            data: storeProducers.map((p: any) => ({
              value: `$${(p.OnHandItemsAmount ?? 0).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}`
            }))
          },
          {
            columnId: 12,
            data: storeProducers.map((p: any) => ({
              value: `$${(p.PotentialRevenue ?? 0).toLocaleString('en-US', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
              })}`
            }))
          },
          {
            columnId: 14,
            data: storeProducers.map((p: any) => ({
              value: `${(p.SellThroughPercentage ?? p.SellThroughPercentageCreatedByUserId ?? 0).toFixed(2)}%`
            }))
          },
          { columnId: 15, data: producerTrendData }
        ]
      };
    });

    const totalProducedQty = stores.reduce((sum: any, store: any) => sum + (store.ProducedQty || 0), 0);
    const totalProducedPrice = stores.reduce((sum: any, store: any) => sum + (store.ProducedPrice || 0), 0);
    const totalSoldQty = stores.reduce((sum: any, store: any) => sum + (store.SoldQty || 0), 0);
    const totalSoldPrice = stores.reduce((sum: any, store: any) => sum + (store.SoldPrice || 0), 0);
    const totalDiscountedItems = stores.reduce((sum: any, store: any) => sum + (store.DiscountedItems || 0), 0);
    const totalDiscountedAmount = stores.reduce((sum: any, store: any) => sum + (store.DiscountedAmount || 0), 0);
    const totalAvgDaysOnFloor = stores.reduce((sum: any, store: any) => sum + (store.AvgDaysOnFloor || 0), 0);
    const totalOnHandItemsAmount = stores.reduce((sum: any, store: any) => sum + (store.OnHandItemsAmount || 0), 0);
    const totalPotentialRevenue = stores.reduce((sum: any, store: any) => sum + (store.PotentialRevenue || 0), 0);
    const totalSellThroughPercentage = totalProducedQty !== 0 ? (totalSoldQty / totalProducedQty) * 100 : 0;
    this.grandTotal = [
      { columnId: 1, total: totalProducedQty },
      {
        columnId: 2,
        total: `$${totalProducedPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      },
      {
        columnId: 3,
        total: `$${(totalProducedQty !== 0 ? totalProducedPrice / totalProducedQty : 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      },
      { columnId: 4, total: totalSoldQty },
      {
        columnId: 5,
        total: `$${totalSoldPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      },
      {
        columnId: 16,
        total: `$${(totalSoldQty !== 0 ? totalSoldPrice / totalSoldQty : 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      },
      { columnId: 6, total: totalDiscountedItems },
      {
        columnId: 7,
        total: `$${totalDiscountedAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      },
      {
        columnId: 10,
        total: (totalAvgDaysOnFloor / (stores.length || 1)).toFixed(2)
      },
      {
        columnId: 11,
        total: `$${totalOnHandItemsAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      },
      {
        columnId: 12,
        total: `$${totalPotentialRevenue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      },
      { columnId: 14, total: `${totalSellThroughPercentage.toFixed(2)}%` },
      { columnId: 15, total: '-' }
    ];
  }

  /* ------------------------------------------------------------------ */
  /* Modal dept/category data  ← KEY FIX                                 */
  /* ------------------------------------------------------------------ */
  /**
   * Builds sellThroughDeptData: one entry per (UserID, DepartmentID) pair.
   *
   * Each entry has:
   *  - deptTotal[]   → 12 metric columns taken directly from the dept row
   *                    (already aggregated by the API for that user+dept)
   *  - categories[]  → each category has its own values[] array so the
   *                    expanded accordion can show one row per category
   *                    with all metric columns aligned.
   */
  formateSellThroughModalData(department: any[], category: any[]) {
    this.sellThroughDeptData = department.map((dept) => {
      // Categories that belong to this exact user + department combination
      const deptCategories = category.filter(
        (ctg) =>
          ctg.DepartmentID === dept.DepartmentID &&
          ctg.CreatedByUserID === dept.CreatedByUserID
      );

      return {
        UserID: dept.CreatedByUserID,
        DepartmentID: dept.DepartmentID,
        deptName: dept.DepartmentDescr,
        isCategoryData: false, // accordion closed by default

        // ── Category rows (used when accordion is OPEN) ──────────────
        categories: deptCategories.map((cat: any) => ({
          CategoryID: cat.CategoryID,
          CategoryName: cat.CategoryName,
          // Flat array of { columnId, total } — consumed by getColValue()
          values: [
            { columnId: 1, total: cat.ProducedQty },
            {
              columnId: 2,
              total: `$${(cat.ProducedPrice ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            },
            {
              columnId: 3,
              total: `$${(cat.AvgAmount ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            },
            { columnId: 4, total: cat.SoldQty },
            {
              columnId: 5,
              total: `$${(cat.SoldPrice ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            },
            {
              columnId: 16,
              total: `$${(cat.AvgSoldPrice ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            },
            { columnId: 6, total: cat.DiscountedItems },
            {
              columnId: 7,
              total: `$${(cat.DiscountedAmount ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            },
            { columnId: 10, total: cat.AvgDaysOnFloor },
            {
              columnId: 11,
              total: `$${(cat.OnHandItemsAmount ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            },
            {
              columnId: 12,
              total: `$${(cat.PotentialRevenue ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
            },
            {
              columnId: 14,
              total: `${(cat.SellThroughPercentage ?? 0).toFixed(2)}%`
            }
          ]
        })),

        deptTotal: [
          { columnId: 1, total: dept.ProducedQty },
          {
            columnId: 2,
            total: `$${(dept.ProducedPrice ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
          },
          {
            columnId: 3,
            total: `$${(dept.AvgAmount ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
          },
          { columnId: 4, total: dept.SoldQty },
          {
            columnId: 5,
            total: `$${(dept.SoldPrice ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
          },
          { columnId: 16, total: `$${(dept.AvgSoldPrice ?? 0).toFixed(2)}` },
          { columnId: 6, total: dept.DiscountedItems },
          {
            columnId: 7,
            total: `$${(dept.DiscountedAmount ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
          },
          { columnId: 10, total: dept.AvgDaysOnFloor },
          {
            columnId: 11,
            total: `$${(dept.OnHandItemsAmount ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
          },
          {
            columnId: 12,
            total: `$${(dept.PotentialRevenue ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
          },
          {
            columnId: 14,
            total: `${(dept.SellThroughPercentage ?? 0).toFixed(2)}%`
          }
        ]
      };
    });
  }

  /* ------------------------------------------------------------------ */
  /* Modal: populate data for the clicked producer                        */
  /* ------------------------------------------------------------------ */
  populateProducerModalTable(userObj: any, storeName: string) {
    this.modalStoreName = storeName;
    this.modalUserName = userObj.UserName;

    // Filter to only this producer's department rows;
    // reset accordion state so all rows start collapsed
    this.sellThroughDeptTableData = this.sellThroughDeptData
      .filter((item: { UserID: any }) => item.UserID === userObj.UserID)
      .map((item: any) => ({ ...item, isCategoryData: false }));
  }

  /* ------------------------------------------------------------------ */
  /* Template helper: look up a column value from a category values[]    */
  /* ------------------------------------------------------------------ */
  getColValue(
    values: { columnId: number; total: any }[],
    columnId: number
  ): any {
    const found = values?.find((v) => v.columnId === columnId);
    return found ? found.total : '-';
  }

  /* ------------------------------------------------------------------ */
  /* Chart                                                                */
  /* ------------------------------------------------------------------ */
  setSellThroughChartParameters(obj: any, opt: number) {
    if (opt === 1) {
      this.chartStoreName = obj.storeName;
      this.storeID = obj.storeId;
      this.userID = 0;
      this.chartUserName = 'Over All';
    }
    if (opt === 2) {
      this.userID = obj.UserID;
      this.chartUserName = obj.UserName;
    }
    this.getSellThroughChart();
  }

  getSellThroughChart() {
    const formattedStartDate = this.datepipe.transform(
      this.startDate,
      'yyyy-MM-dd HH:mm:ss'
    );
    const formattedEndDate = this.datepipe.transform(
      this.endDate,
      'yyyy-MM-dd HH:mm:ss'
    );

    this.masterService
      .getSellThroughChart(
        this.userInfo.companyID,
        this.storeID,
        this.userID,
        this.deptId,
        this.categoryId,
        formattedStartDate,
        formattedEndDate,
        this.productionCycleId,
        this.subCategoryId
      )
      .subscribe(
        (res: any) => {
          const chartData = res.rate;
          this.noChartData = chartData.length === 0;

          this.sellThroughChart = chartData.map(
            (item: {
              createdDate: string | number | Date;
              sellThroughPercentage: any;
            }) => ({
              date: this.datepipe.transform(
                new Date(item.createdDate),
                'MMM d'
              )!,
              sellThroughPercentage: item.sellThroughPercentage.toFixed(2)
            })
          );
          this.updateChart();
        },
        () => {}
      );
  }

  updateChart() {
    this.destroyCharts();
    setTimeout(() => {
      this.renderChart();
    }, 100);
  }

  getUsersByStore(storeID: number) {
    this.sellThroughData?.forEach((item: any) => {
      if (item.storeID === storeID) this.usersArray = item.producers;
    });
  }

  renderDynamicTrendChart(storeAndProducerTrend: any, topProducers: any) {
    storeAndProducerTrend.forEach((item: any) => {
      const storeId = item.storeID;
      const trend = item.storeTotal.find((t: any) => t.columnId === 15).total;
      this.renderTrendCharts(trend, storeId);
    });

    storeAndProducerTrend.forEach((item: any) => {
      const producerData = item.measuredValues
        .filter((mv: any) => mv.columnId === 15)
        .map((mv: any) => mv.data);

      if (producerData[0]) {
        producerData[0].forEach((res: any) => {
          this.renderTrendCharts(res.data, res.producerID);
        });
      }
    });

    topProducers.forEach((item: any) => {
      const topProducerTrend = item.prdData
        .filter((d: any) => d.columnID === 7)
        .map((d: any) => d.value);
      topProducerTrend.forEach((res: any) => {
        this.renderTrendCharts(res.data, res.producerID);
      });
    });
  }

  renderTrendCharts(trend: any[], storeId: string) {
    Chart.register(...registerables);
    Chart.register(ChartDataLabels);

    const ctx = document.getElementById(storeId) as HTMLCanvasElement;
    if (!ctx) {
      return;
    }

    new Chart(ctx, {
      type: 'line',
      data: {
        labels: trend.map((item: { date: any }) => item.date),
        datasets: [
          {
            label: 'Sell through rate',
            data: trend.map((item) => item.sellThroughPercentage),
            backgroundColor: '#66BB6A',
            borderColor: '#66BB6A',
            pointRadius: 0,
            tension: 0.4
          }
        ]
      },
      options: {
        scales: {
          x: {
            display: false,
            border: { display: false },
            grid: { display: false }
          },
          y: {
            display: false,
            border: { display: false },
            grid: { display: false }
          }
        },
        plugins: {
          legend: { display: false },
          datalabels: { display: false }
        },
        maintainAspectRatio: false,
        responsive: true
      }
    });
  }

  renderChart() {
    Chart.register(...registerables);
    Chart.register(ChartDataLabels);

    let chartData = this.sellThroughChart.map((item) => ({
      x: item.date,
      y: item.sellThroughPercentage
    }));

    if (chartData.length === 1) {
      chartData.push({ x: '', y: chartData[0].y * 0.99 });
    }

    this.salesGraph = new Chart('salesStatistics', {
      type: 'line',
      data: {
        labels: chartData.map((item) => item.x),
        datasets: [
          {
            label: 'Sell through rate',
            data: chartData.map((item) => item.y),
            backgroundColor: '#66BB6A',
            borderColor: '#66BB6A',
            pointRadius: chartData.length === 1 ? 4 : 0,
            spanGaps: true
          }
        ]
      },
      options: {
        scales: {
          x: {
            display: true,
            border: { display: false },
            grid: { display: false }
          },
          y: {
            display: true,
            border: { display: false },
            grid: { display: false }
          }
        },
        plugins: {
          legend: { display: false },
          datalabels: { display: false }
        },
        maintainAspectRatio: false,
        responsive: true
      }
    });

    this.charts = [this.salesGraph];
  }

  destroyCharts() {
    this.charts.forEach((chart) => {
      if (chart) {
        chart.destroy();
      }
    });
    this.charts = [];
  }

  changeSalesData(item: string, i: number) {
    this.reportTypeOption = item;
  }

  toggleProducersData(item: any) {
    item.isProducersData = !item.isProducersData;
  }

  toggleCategoryData(item: any) {
    item.isCategoryData = !item.isCategoryData;
  }

  getWeekColors() {
    let user = this.masterService.getUserDetailsFromStorage();
    this.weekColorService
      .getProductionCycles(user.companyID)
      .subscribe((res) => {
        this.weekColorsList = res as ProductionCycle[];
        this.weekColorsList = this.weekColorsList.filter(
          (item) => item.status === OverrideStatus.Active
        );
      });
  }

  toggleAllColors() {
    this.weekColorHeaderSelected = !this.weekColorHeaderSelected;
    if (!this.disableCategory) this.disableCategory = true;
  }

  selectAllcolors() {
    this.weekColor = 'All Week Colors';
    this.productionCycleId = 0;
  }

  isNumber(value: any): boolean {
    return typeof value === 'number';
  }
}
